import React from "react";
import { useTranslation } from "react-i18next";

import { CircularProgressBar } from "@common/circularProgressBar";
import { Props } from "./types";
import styles from "./styles.scss";

function toFixed(nbr: number) {
  return typeof nbr !== "undefined"
    ? Math.round(nbr) === nbr
      ? nbr
      : nbr.toFixed(2)
    : "";
}

function DateMonitoring({ synthesis }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.monitoring}>
      <div className={styles.col}>
        <div className={styles.row}>
          <div className={styles.graph}>
            <div className={styles.bar}>
              <CircularProgressBar
                progress={parseFloat(synthesis.percentOfBudgetConsumption)}
                size={90}
                barColor="#0096C769"
                progressColor="#0096C7"
                strokeWidth={7.5}
              />
              <p className={styles.percentage}>
                {toFixed(parseFloat(synthesis.percentOfBudgetConsumption))}%
              </p>
            </div>
            <p className={styles.label}>
              {t(
                "projectBudgetSynthesis.monitoring.percentOfBudgetConsumption",
              )}
            </p>
          </div>
          <div className={styles.graph}>
            <div className={styles.bar}>
              <CircularProgressBar
                progress={parseFloat(synthesis.percentOfAcquiredValue)}
                size={90}
                barColor="#0096C769"
                progressColor="#0096C7"
                strokeWidth={7.5}
              />
              <p className={styles.percentage}>
                {toFixed(parseFloat(synthesis.percentOfAcquiredValue))}%
              </p>
            </div>
            <p className={styles.label}>
              {t("projectBudgetSynthesis.monitoring.percentOfAcquiredValue")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export { DateMonitoring };
